export enum PaymentRateType {
  HOURLY = 'HOURLY'
}

export const PAYMENT_RATE_MAP = {
  [PaymentRateType.HOURLY]: 'Hourly',
};